<div class="cb-layout-row" [class.cb-scrollable]="scrollable()" [style.align-items]="alignStyle()"
    [style.justify-content]="justifyStyle()">
    <ng-content></ng-content>
</div>